/**
 * CNC Delivery dashboard — display helpers.
 * Live data from GET /api/cnc-degen/board
 */

export const CNC_PIPELINE_STAGES = [
  { id: 1, key: 'scan', label: 'SCAN', desc: 'NSE + BSE delivery universe' },
  { id: 2, key: 'predict', label: 'PREDICT', desc: 'Swing UP confidence' },
  { id: 3, key: 'validate', label: 'VALIDATE', desc: 'RSI + trend filters' },
  { id: 4, key: 'size', label: 'SIZE', desc: '50 shares · CNC qty' },
  { id: 5, key: 'fill', label: 'CNC BUY', desc: 'Delivery order · NSE/BSE' },
  { id: 6, key: 'settle', label: 'HOLD/SELL', desc: '+1% sell · 10m → HOLD · slot free' }
];

export function formatRs(n) {
  const v = Math.round(Number(n) || 0);
  return `₹${v.toLocaleString('en-IN')}`;
}

export function formatSpot(n) {
  return formatRs(n);
}

export function utcClockString(d = new Date()) {
  return d.toISOString().slice(11, 19);
}

export function pipelineStageStatus(activeStage, index) {
  if (index < activeStage) return 'done';
  if (index === activeStage) return 'active';
  return 'pending';
}

export function defaultCncBoard() {
  return {
    ok: false,
    mode: 'CNC DELIVERY · NSE/BSE',
    productType: 'CNC',
    pipelineLabel: '6-CYCLE CNC PIPELINE',
    month: new Date().toLocaleString('en-US', { month: 'long' }),
    realizedPnl: 0,
    tradeCount: 0,
    winRate: 0,
    winStreak: 0,
    nextCycleSec: 5,
    activeStage: 0,
    stageProgress: 0,
    cycleMeta: {},
    direction: 'UP',
    leverage: 70,
    spotSymbol: 'NIFTY',
    spotPrice: 0,
    candles: [],
    pnl24: [],
    winStack: [],
    pipelineRunning: true,
    scanResults: [],
    positions: [],
    profitTargetPct: 1,
    actionProfitTargetPct: 1,
    actionStopPct: 0,
    stopPct: 0,
    maxIntradayHoldMin: 10,
    maxPositions: 5,
    activeSlots: 0,
    minSharePrice: 10,
    maxSharePrice: 100,
    stockQty: 50,
    lastAction: 'Connecting to CNC delivery engine…',
    activityLog: [],
    marketOpen: false,
    cash: 1000000,
    universeSize: 0,
    nseCount: 0,
    bseCount: 0
  };
}
